import React, { useState, useEffect } from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Package, Wrench, Image as ImageIcon, Newspaper, EnvelopeOpen, SignOut, House, VideoCamera, UsersThree, Envelope, Receipt, Calendar } from "@phosphor-icons/react";

const nav = [
  { to: "/admin",                       label: "Dashboard",   icon: House,         perm: null,        match: "exact" },
  { to: "/admin/products",              label: "Products",    icon: Package,       perm: "products" },
  { to: "/admin/services",              label: "Services",    icon: Wrench,        perm: "services" },
  { to: "/admin/portfolio",             label: "Portfolio",   icon: ImageIcon,     perm: "portfolio" },
  { to: "/admin/blog",                  label: "Blog",        icon: Newspaper,     perm: "blog" },
  { to: "/admin/vlogs",                 label: "Vlogs",       icon: VideoCamera,   perm: "vlogs" },
  { to: "/admin/inbox?tab=contacts",    label: "Messages",    icon: EnvelopeOpen,  perm: "inbox", inboxTab: "contacts" },
  { to: "/admin/inbox?tab=quotes",      label: "Quotes",      icon: Receipt,       perm: "inbox", inboxTab: "quotes" },
  { to: "/admin/inbox?tab=bookings",    label: "Bookings",    icon: Calendar,      perm: "inbox", inboxTab: "bookings" },
  { to: "/admin/inbox?tab=newsletter",  label: "Subscribers", icon: Envelope,      perm: "inbox", inboxTab: "newsletter" },
  { to: "/admin/users",                 label: "Team",        icon: UsersThree,    perm: "users" },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-10 text-gray-400">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const canSee = (item) => {
    if (!item.perm) return true;
    if (user.role === "admin") return true; // admins see everything
    const perms = user.permissions || [];
    return perms.includes("all") || perms.includes(item.perm);
  };
  const visibleNav = nav.filter(canSee);

  return (
    <div className="min-h-screen grid lg:grid-cols-[260px_1fr]" data-testid="admin-layout">
      <aside className="bg-[#0a0a0c] border-r border-white/5 p-6 lg:sticky lg:top-0 lg:h-screen">
        <Link to="/" className="block mb-10" data-testid="admin-logo">
          <img src="/mpsound-logo-neon.png" alt="MP Sound" className="h-10 w-auto" />
          <div className="label-tag mt-2">Admin Console</div>
        </Link>
        <nav className="flex flex-col gap-1">
          {visibleNav.map((n) => {
            const Ic = n.icon;
            let active;
            if (n.match === "exact") {
              active = loc.pathname === n.to;
            } else if (n.inboxTab) {
              const currentTab = new URLSearchParams(loc.search).get("tab") || "contacts";
              active = loc.pathname === "/admin/inbox" && currentTab === n.inboxTab;
            } else {
              active = loc.pathname.startsWith(n.to.split("?")[0]) && n.to !== "/admin";
            }
            return (
              <Link key={n.to} to={n.to}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-3 py-2.5 text-sm uppercase mono-font tracking-wider transition-colors ${
                  active ? "bg-[#ccff00] text-black" : "text-gray-300 hover:bg-white/5 hover:text-white"
                }`}>
                <Ic size={18} weight={active ? "bold" : "regular"} /> {n.label}
              </Link>
            );
          })}
        </nav>
        <button onClick={logout} data-testid="admin-logout"
          className="flex items-center gap-3 px-3 py-2.5 text-sm uppercase mono-font tracking-wider text-gray-400 hover:text-[#ff003c] mt-10">
          <SignOut size={18} /> Sign out
        </button>
      </aside>

      <main className="p-6 sm:p-10">
        <Outlet />
      </main>
    </div>
  );
}
